import React from 'react'
import { Avatar } from '@mui/material'

import './LeaderBoard.scss'
import Logo from 'assets/leaderboard-logo.png'
import Mask2 from 'assets/masks/mask2.png'
import Mask1 from 'assets/masks/mask1.png'
import Mask3 from 'assets/masks/mask3.png'
import { fNumber } from 'helpers/common'
import useLeaders from 'hooks/useLeaders'
import LeadersTable from './LeadersTable'

const AvatarPlaceholder = () => (
  <Avatar sx={{ width: '80px', height: '80px' }} />
)

const LeaderBoard: React.FC = () => {
  const { leaders, isFetching } = useLeaders()

  const [firstPlace, secondPlace, thirdPlace, ...restLeaders] = leaders

  return (
    <div className="LeaderBoard">
      <header>
        <div className="LeaderBoard__header-main">
          <div className="LeaderBoard__title">Leaderboard</div>
          <img width={58} src={Logo} height="auto" alt="LeaderBoard logo" />
        </div>
        <p className="LeaderBoard__header-info">
          See where you stand and challenge your friends
        </p>
      </header>

      <section className="LeaderBoard__winners">
        <div className="LeaderBoard__winner second">
          <div className="LeaderBoard__winner-photo-wrapper">
            <img
              className="LeaderBoard__winner-photo-mask"
              width={155}
              height={155}
              src={Mask2}
              alt="mask"
            />

            {!isFetching && secondPlace?.photo_url ? (
              <img
                className="LeaderBoard__winner-photo"
                width={74}
                src={secondPlace?.photo_url}
                alt=""
              />
            ) : (
              <AvatarPlaceholder />
            )}

            <div className="LeaderBoard__winner-place second">
              <div>2</div>
            </div>
          </div>

          <div className="LeaderBoard__winner-name">
            <div>{secondPlace?.first_name}</div>
            <div>{secondPlace?.last_name}</div>
          </div>
          <div className="LeaderBoard__winner-points">
            {fNumber(secondPlace?.points)} pts
          </div>
        </div>

        <div className="LeaderBoard__winner first">
          <div className="LeaderBoard__winner-photo-wrapper">
            <img
              className="LeaderBoard__winner-photo-mask first"
              width={200}
              height={180}
              src={Mask1}
              alt="mask"
            />

            {!isFetching && firstPlace?.photo_url ? (
              <img
                className="LeaderBoard__winner-photo"
                width={74}
                src={firstPlace?.photo_url}
                alt=""
              />
            ) : (
              <AvatarPlaceholder />
            )}

            <div className="LeaderBoard__winner-place first">
              <div>1</div>
            </div>
          </div>

          <div className="LeaderBoard__winner-name">
            <div>{firstPlace?.first_name}</div>
            <div>{firstPlace?.last_name}</div>
          </div>
          <div className="LeaderBoard__winner-points">
            {fNumber(firstPlace?.points)} pts
          </div>
        </div>

        <div className="LeaderBoard__winner third">
          <div className="LeaderBoard__winner-photo-wrapper">
            {!isFetching && thirdPlace?.photo_url ? (
              <img
                className="LeaderBoard__winner-photo"
                width={74}
                src={thirdPlace?.photo_url}
                alt=""
              />
            ) : (
              <AvatarPlaceholder />
            )}

            <img
              className="LeaderBoard__winner-photo-mask"
              width={155}
              height={155}
              src={Mask3}
              alt="mask"
            />

            <div className="LeaderBoard__winner-place third">
              <div>3</div>
            </div>
          </div>

          <div className="LeaderBoard__winner-name">
            <div>{thirdPlace?.first_name}</div>
            <div>{thirdPlace?.last_name}</div>
          </div>
          <div className="LeaderBoard__winner-points">
            {fNumber(thirdPlace?.points)} pts
          </div>
        </div>
      </section>

      <LeadersTable leaders={restLeaders} isFetching={isFetching} />
    </div>
  )
}

export default React.memo(LeaderBoard)
